import * as components from './components'
import * as hooks from './hooks'
import * as types from './types'

console.log('Customer Accounts feature initialized!')

export { components, hooks, types }
